module.exports = __webpack_public_path__ + "media/10.e2ffdf07.mp3";